import React from 'react';
import PropTypes from 'prop-types';
import { useFeatureFlag } from 'common/hooks';
import { AUTHORIZATION_STATUSES } from 'common/Status/authorizationConstants';
import { AssignToUserWidget } from 'common/Workqueue/AssignToUserWidget';
import { useAssigneeOptions, REQUEST_UNASSIGNED } from 'common/Workqueue/hooks/useAssigneeOptions';
import { useUpdateServiceAuthorization } from '../hooks/useUpdateServiceAuthorization';

const AssignUserToAuth = ({ authorizationId, currentAssigneeId, state }) => {
  // TODO this is temporary while the backend is still rejecting updates on
  // approved/rejected authorizations. all states _should_ be assignable.
  const isAssignableState = [AUTHORIZATION_STATUSES.open, AUTHORIZATION_STATUSES.inReview].includes(state);
  const inReviewFeatureEnabled = useFeatureFlag('pays-8984-auth-assign-in-review');
  const assigneeOptions = useAssigneeOptions('service_authorizations', inReviewFeatureEnabled);
  const updateServiceAuthorization = useUpdateServiceAuthorization();
  const onAssignmentChange = async (assigneeId) => {
    await updateServiceAuthorization(
      authorizationId,
      { assignee: assigneeId },
      assigneeId === REQUEST_UNASSIGNED ? 'Request successfully unassigned' : 'Request successfully assigned',
    );
  };

  return (isAssignableState && inReviewFeatureEnabled) ? (
    <AssignToUserWidget
      assigneeOptions={assigneeOptions}
      currentAssigneeId={currentAssigneeId}
      onAssignmentChange={onAssignmentChange}
    />
  ) : null;
};

AssignUserToAuth.propTypes = {
  authorizationId: PropTypes.string.isRequired,
  currentAssigneeId: PropTypes.string,
  state: PropTypes.oneOf(AUTHORIZATION_STATUSES).isRequired,
};

AssignUserToAuth.defaultProps = {
  currentAssigneeId: null,
};

export default AssignUserToAuth;
